<script lang="ts">
	import Header from '$lib/components/organisms/Header/Header.svelte';
	import Footer from '$lib/components/organisms/Footer/Footer.svelte';
	import { page } from '$app/stores';
	import { getMenu } from '$lib/utils';
	import SideBarDesktop from '$lib/components/molecules/SideBarDesktop/SideBarDesktop.svelte';
	import { compareModeStore } from '$store/persistedIDStore';
	import { PAGES } from '$lib/consts';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	/*
	 * This is the main layout with default header and footer
	 */

	const isPageWithFullWidthContent = (pathname: string): boolean => {
		return (
			[
				PAGES.termsOfUse,
				PAGES.investorRightsFunds,
				PAGES.investorRightsFundsIndex,
				PAGES.investorRightsPrivado
			].includes(pathname) || pathname.includes(PAGES.termsAndConditions)
		); // TODO: Need to align the usage
	};

	let menuConfig = $derived(getMenu($page.data?.userInfo, $compareModeStore));
	let isMainPage = $derived($page.url.pathname === '/');
	let showFullWidthContent = $derived(isPageWithFullWidthContent($page.url.pathname));
</script>

{#key $page.data?.userInfo}
	<SideBarDesktop menu={menuConfig}></SideBarDesktop>
{/key}

<div class:content={!showFullWidthContent} class:content--full-width={showFullWidthContent}>
	<Header animated={isMainPage} menu={menuConfig}></Header>

	<main class="main">
		{@render children?.()}
	</main>

	<Footer centered={showFullWidthContent}></Footer>
</div>

<style lang="scss">
	@use '$scss/mixins/mediaqueries' as mq;
	@use '$scss/mixins/units' as u;
	@use '$scss/mixins/layout' as l;

	.main {
		flex: 1;
		position: relative;

		@include mq.above-mobile {
			min-height: calc(100vh - l.$footer-height-desktop);
		}
	}

	.content {
		@include mq.above-mobile {
			position: relative;
			margin-left: u.rem(320);

			&--full-width {
				margin-left: u.rem(100);
			}
		}
	}
</style>
